module.exports = __webpack_public_path__ + "static/media/c6_mobile.2a78dbc7.png";